/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {UserGroupFormComponent as ɵc} from './usergroup-form/usergroup-form.component';
export {UserGroupComponent as ɵb} from './usergroup.component';
export {declaration as ɵa} from './usergroup.module';
export {UserGroupRoutes as ɵd} from './usergroup.routing';